export default __webpack_public_path__ + "static/media/user2.e6312a60.png";